import { withChartLayout } from 'components/common';
import PsychosocialScreen from 'components/features/chart/admission-history/psychosocial-screen/PsychosocialScreen';

const PsychosocialScreenPage = withChartLayout('Psychosocial Screen')(PsychosocialScreen);
export default PsychosocialScreenPage;
